import withPreventDoubleClick from "../../utils/withPreventDoubleClick";
import { TouchableRipple } from "react-native-paper";
import React, { useEffect } from "react";
import Animated, {
  useSharedValue,
  withTiming,
  useAnimatedStyle,
  Easing,
  runOnJS,
  cancelAnimation,
} from "react-native-reanimated";
import { theme } from "@common/theme/theme";

// Helper to lighten a 6-digit hex color by given percent
export function lightenHexColor(hex, percent) {
  const normalized = hex.startsWith('#') ? hex.slice(1) : hex;
  if (!/^[0-9A-Fa-f]{6}$/.test(normalized)) {
    console.warn('Invalid hex color: ' + hex);
    return hex;
  }
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  const newR = Math.round(r + (255 - r) * percent / 100);
  const newG = Math.round(g + (255 - g) * percent / 100);
  const newB = Math.round(b + (255 - b) * percent / 100);
  const toHex = c => c.toString(16).padStart(2, '0');
  return '#' + toHex(newR) + toHex(newG) + toHex(newB);
}

function TouchableRippleM(props) {
  const {
    autoClickDuration,
    autoClickColor,
    autoClickPaused,
    onPress,
    onAutoClick,
    style,
    children,
    ...rest
  } = props;
  const progress = useSharedValue(0);
  const overlayStyle = useAnimatedStyle(() => ({
    width: `${progress.value * 100}%`,
  }));

  useEffect(() => {
    if (!autoClickDuration) return;
    if (autoClickPaused) {
      cancelAnimation(progress);
    } else {
      const remainingDuration = (1 - progress.value) * autoClickDuration;
      progress.value = withTiming(1, {
        duration: remainingDuration,
        easing: Easing.linear,
      }, (finished) => {
        'worklet';
        if (finished) {
          if (onAutoClick) {
            runOnJS(onAutoClick)();
          } else if (onPress) {
            runOnJS(onPress)();
          }
        }
      });
    }
  }, [autoClickDuration, autoClickPaused]);

  const bgColor = autoClickColor
    ? lightenHexColor(autoClickColor, 50)
    : lightenHexColor(theme.colors.primary, 50);
  const containerStyle = autoClickDuration
    ? [{ overflow: 'hidden', position: 'relative', backgroundColor: bgColor }, style]
    : style;

  return (
    <TouchableRipple onPress={onPress} style={containerStyle} {...rest}>
        <>
      {autoClickDuration && (
        <Animated.View
          style={[
            { position: 'absolute', left: 0, top: 0, bottom: 0, backgroundColor: autoClickColor },
            overlayStyle,
          ]}
        />
      )}
      {children}
      </>
    </TouchableRipple>
  );
}

export default withPreventDoubleClick(TouchableRippleM);